import MedDetail from "./MedDetail";

export default MedDetail;
